import moment from "moment";
import { ReplaceBookingsRangePayload } from "PFApp/booking/services/api";
import { hoursToMinutes, ISO_DATE_FORMAT } from "PFCore/helpers/date";
import { CalendarGranularity } from "PFCore/hooks/queries/profile/use_profiles_availabilities";
import { RequirementType } from "PFTypes/booking/booking";

import { PendingEdit } from "../booking_edit_mode_store.types";

type EditGroup = Array<[string, PendingEdit]>;

export const groupEditsByActivityAndProfile = (
  pendingEntries: Array<[string, PendingEdit]>
): Map<string, EditGroup> =>
  Map.groupBy(
    pendingEntries,
    ([, edit]) => `${edit.profileId}_${edit.activityId ?? edit.bookingCategoryId ?? ""}`
  );

const getDateRange = (
  date: string,
  calendarGranularity: CalendarGranularity
): { startDate: string; endDate: string } => {
  if (calendarGranularity === CalendarGranularity.Weekly) {
    const startDate = moment.utc(date).startOf("isoWeek").format(ISO_DATE_FORMAT);
    const endDate = moment.utc(date).startOf("isoWeek").add(4, "days").format(ISO_DATE_FORMAT);

    return { startDate, endDate };
  }
  const formattedDate = moment.utc(date).format(ISO_DATE_FORMAT);

  return { startDate: formattedDate, endDate: formattedDate };
};

export const createPayload = (
  editGroup: EditGroup,
  calendarGranularity: CalendarGranularity
): ReplaceBookingsRangePayload => {
  const [, firstEdit] = editGroup[0];
  const isDaily = calendarGranularity === CalendarGranularity.Daily;

  return {
    filters: {
      activityId: firstEdit.activityId,
      profileId: firstEdit.profileId,
      bookingCategoryId: firstEdit.bookingCategoryId
    },
    data: editGroup.map(([, edit]) => {
      const { startDate, endDate } = getDateRange(edit.date, calendarGranularity);
      return {
        startDate,
        endDate,
        requirementValue: hoursToMinutes(edit.value),
        requirementType: RequirementType.TotalHours,
        bookingCategoryId: edit.bookingCategoryId,
        activityId: edit.activityId,
        overridesCalendar: true,
        ...(isDaily && { overridesNonWorkingDays: true })
      };
    })
  } as ReplaceBookingsRangePayload;
};
